export const buttonStyles = {
   borderRadius: "5px",
   padding: "12px 24px 12px 16px",
   background: "#1b202c",
   color: "white",
   border: "1px #5B667D solid",
   boxShadow: "3px 3px 8px rgba(0,0,0,.5)",
   display: "flex",
   justifyContent: "center",
   alignItems: "center",
   cursor: "pointer",
}
export const zestyStyles = {
   flex: "1",
   display: "inline-block",
   alignSelf: "center",
   marginLeft: "12px",
   fontSize: "18px",
   color: "#C7D4EA",
   letterSpacing: "1px",
   fontFamily: "'Arial Rounded MT Bold','Helvetica Rounded',Arial,sans-serif",
}

export const zestyWrapper = {
   overflow: "hidden",
   width: "auto",
   background: "transparent",
   position: "fixed",
   bottom: "20px",
   right: "20px",
   zIndex: "9999999999999999",
   padding: "2rem",
}
